import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { IconNames, IconSizes } from 'atoms/Icon'
import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Backgrounds, Corners, LabelsOrder, Paddings } from '../Label.h'

export type ILabelExternalContentProps = ILabelProps

export const LabelExternalContent = ({
  background = Backgrounds.ACCENT_TERTIARY,
  padding = Paddings.SIZE_80,
  color = COLOR.TEXT_ICON_PRIMARY,
  corners = Corners.CORNERS_10,
  order = LabelsOrder.ORDER_3,
  iconSize = IconSizes.mSm,
  icon = IconNames.externalContent,
  ...rest
}: ILabelExternalContentProps): JSX.Element => (
  <Label
    background={background}
    padding={padding}
    color={color}
    corners={corners}
    order={order}
    iconSize={iconSize}
    icon={icon}
    {...rest}
  />
)
